import { Create, useForm } from '@refinedev/antd';
import { useMemo } from 'react';

import { COUNTRY, useCountryContext } from '@/contexts/CountryContext';
import { Shipper } from '@/model/Logistic/Shipper/Shipper';

import ShipperForm from './ShipperForm/ShipperForm';

const ShipperCreate = () => {
  const { formProps, saveButtonProps } = useForm<Shipper>();
  const { isBrasilSelected } = useCountryContext();
  // Inicializa el país por defecto: Brasil si el contexto es Brasil, Argentina en caso contrario.
  // Esto garantiza que el select de país arranque con un valor y los selects dependientes
  // (provincia/localidad) se habiliten correctamente desde el primer render.
  const initialValuesModified = useMemo(
    () => ({ pais: isBrasilSelected ? COUNTRY.BRASIL : COUNTRY.ARGENTINA }),
    [isBrasilSelected],
  );

  return (
    <Create saveButtonProps={saveButtonProps}>
      <ShipperForm formProps={formProps} initialValuesModified={initialValuesModified} />
    </Create>
  );
};

export default ShipperCreate;
